export default function (state, action) {
    if (!state) {
        state = {
            listed: [],
        };
    }

    switch (action.type) {
        case 'USER_CONNECTIONS':
            state = {...state, listed: action.connections};
            break;
        case 'UPDATE_USER':
            state = {
                ...state,
                listed: state.listed.map(user =>
                    user.id == action.userId
                        ? {
                              ...user,
                              ...action.user,
                          }
                        : user
                ),
            };
            break;
    }

    return state;
}
